
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {FilterEnum} from './FilterEnum';
import {FieldModelFilterEnum} from './FilterEnum';
import {FilterUint64} from './FilterUint64';
import {FieldModelFilterUint64} from './FilterUint64';
import {FilterDouble} from './FilterDouble';
import {FieldModelFilterDouble} from './FilterDouble';

/**
 * SocialTradingMasterAccountFiltration struct
 */
class SocialTradingMasterAccountFiltration {
  /**
   * Initialize struct
   * @param {FilterEnum=} allocationMethod
   * @param {FilterEnum=} accountMode
   * @param {FilterUint64=} commissionLogin
   * @param {FilterDouble=} feePercent
   * @constructor
   */
  constructor (allocationMethod = null, accountMode = null, commissionLogin = null, feePercent = null) {
    this.AllocationMethod = allocationMethod
    this.AccountMode = accountMode
    this.CommissionLogin = commissionLogin
    this.FeePercent = feePercent
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SocialTradingMasterAccountFiltration}
   * @param {!SocialTradingMasterAccountFiltration} other Other struct
   * @returns {!SocialTradingMasterAccountFiltration} This struct
   */
  copy (other) {
    if (other.AllocationMethod != null) {
      this.AllocationMethod = FilterEnum.fromObject(other.AllocationMethod)
    } else {
      this.AllocationMethod = null
    }
    if (other.AccountMode != null) {
      this.AccountMode = FilterEnum.fromObject(other.AccountMode)
    } else {
      this.AccountMode = null
    }
    if (other.CommissionLogin != null) {
      this.CommissionLogin = FilterUint64.fromObject(other.CommissionLogin)
    } else {
      this.CommissionLogin = null
    }
    if (other.FeePercent != null) {
      this.FeePercent = FilterDouble.fromObject(other.FeePercent)
    } else {
      this.FeePercent = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SocialTradingMasterAccountFiltration}
   * @returns {!SocialTradingMasterAccountFiltration} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SocialTradingMasterAccountFiltrationModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SocialTradingMasterAccountFiltrationModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SocialTradingMasterAccountFiltration}
   * @param {!SocialTradingMasterAccountFiltration} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingMasterAccountFiltration)) {
      throw new TypeError('Instance of SocialTradingMasterAccountFiltration is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SocialTradingMasterAccountFiltration}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      AllocationMethod: ((this.AllocationMethod != null) ? this.AllocationMethod : null),
      AccountMode: ((this.AccountMode != null) ? this.AccountMode : null),
      CommissionLogin: ((this.CommissionLogin != null) ? this.CommissionLogin : null),
      FeePercent: ((this.FeePercent != null) ? this.FeePercent : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SocialTradingMasterAccountFiltration.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SocialTradingMasterAccountFiltration} other Object value
   * @returns {!SocialTradingMasterAccountFiltration} Created struct
   */
  static fromObject (other) {
    return new SocialTradingMasterAccountFiltration().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SocialTradingMasterAccountFiltration}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SocialTradingMasterAccountFiltration.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SocialTradingMasterAccountFiltration}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 134
  }
}

export { SocialTradingMasterAccountFiltration };

/**
 * Fast Binary Encoding SocialTradingMasterAccountFiltration field model
 */
class FieldModelSocialTradingMasterAccountFiltration extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.AllocationMethod = new fbe.FieldModelOptional(new FieldModelFilterEnum(buffer, 4 + 4), buffer, 4 + 4)
    this.AccountMode = new fbe.FieldModelOptional(new FieldModelFilterEnum(buffer, this.AllocationMethod.fbeOffset + this.AllocationMethod.fbeSize), buffer, this.AllocationMethod.fbeOffset + this.AllocationMethod.fbeSize)
    this.CommissionLogin = new fbe.FieldModelOptional(new FieldModelFilterUint64(buffer, this.AccountMode.fbeOffset + this.AccountMode.fbeSize), buffer, this.AccountMode.fbeOffset + this.AccountMode.fbeSize)
    this.FeePercent = new fbe.FieldModelOptional(new FieldModelFilterDouble(buffer, this.CommissionLogin.fbeOffset + this.CommissionLogin.fbeSize), buffer, this.CommissionLogin.fbeOffset + this.CommissionLogin.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.AllocationMethod.fbeSize + this.AccountMode.fbeSize + this.CommissionLogin.fbeSize + this.FeePercent.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.AllocationMethod.fbeExtra + this.AccountMode.fbeExtra + this.CommissionLogin.fbeExtra + this.FeePercent.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSocialTradingMasterAccountFiltration.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 134
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AllocationMethod.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AllocationMethod.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllocationMethod.fbeSize

    if ((fbeCurrentSize + this.AccountMode.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountMode.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMode.fbeSize

    if ((fbeCurrentSize + this.CommissionLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionLogin.fbeSize

    if ((fbeCurrentSize + this.FeePercent.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FeePercent.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeePercent.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @param {!SocialTradingMasterAccountFiltration} fbeValue Default value, defaults is new SocialTradingMasterAccountFiltration()
   * @returns {!SocialTradingMasterAccountFiltration} SocialTradingMasterAccountFiltration value
   */
  get (fbeValue = new SocialTradingMasterAccountFiltration()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @param {!SocialTradingMasterAccountFiltration} fbeValue SocialTradingMasterAccountFiltration value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AllocationMethod.fbeSize) <= fbeStructSize) {
      fbeValue.AllocationMethod = this.AllocationMethod.get()
    } else {
      fbeValue.AllocationMethod = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllocationMethod.fbeSize

    if ((fbeCurrentSize + this.AccountMode.fbeSize) <= fbeStructSize) {
      fbeValue.AccountMode = this.AccountMode.get()
    } else {
      fbeValue.AccountMode = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMode.fbeSize

    if ((fbeCurrentSize + this.CommissionLogin.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionLogin = this.CommissionLogin.get()
    } else {
      fbeValue.CommissionLogin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionLogin.fbeSize

    if ((fbeCurrentSize + this.FeePercent.fbeSize) <= fbeStructSize) {
      fbeValue.FeePercent = this.FeePercent.get()
    } else {
      fbeValue.FeePercent = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeePercent.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @param {!SocialTradingMasterAccountFiltration} fbeValue SocialTradingMasterAccountFiltration value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSocialTradingMasterAccountFiltration}
   * @param {SocialTradingMasterAccountFiltration} fbeValue SocialTradingMasterAccountFiltration value
   */
  setFields (fbeValue) {
    this.AllocationMethod.set(fbeValue.AllocationMethod)
    this.AccountMode.set(fbeValue.AccountMode)
    this.CommissionLogin.set(fbeValue.CommissionLogin)
    this.FeePercent.set(fbeValue.FeePercent)
  }
}

export { FieldModelSocialTradingMasterAccountFiltration };

/**
 * Fast Binary Encoding SocialTradingMasterAccountFiltration model
 */
class SocialTradingMasterAccountFiltrationModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSocialTradingMasterAccountFiltration(this.buffer, 4)
  }

  /**
   * Get the SocialTradingMasterAccountFiltration model
   * @this {!SocialTradingMasterAccountFiltrationModel}
   * @returns {!FieldModelSocialTradingMasterAccountFiltration} model SocialTradingMasterAccountFiltration model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SocialTradingMasterAccountFiltrationModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SocialTradingMasterAccountFiltrationModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SocialTradingMasterAccountFiltrationModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SocialTradingMasterAccountFiltrationModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSocialTradingMasterAccountFiltration.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SocialTradingMasterAccountFiltrationModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SocialTradingMasterAccountFiltrationModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SocialTradingMasterAccountFiltrationModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SocialTradingMasterAccountFiltrationModel}
   * @param {!SocialTradingMasterAccountFiltration} value SocialTradingMasterAccountFiltration value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SocialTradingMasterAccountFiltrationModel}
   * @param {!SocialTradingMasterAccountFiltration} value SocialTradingMasterAccountFiltration value, defaults is new SocialTradingMasterAccountFiltration()
   * @return {!object} Deserialized SocialTradingMasterAccountFiltration value and its size
   */
  deserialize (value = new SocialTradingMasterAccountFiltration()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SocialTradingMasterAccountFiltration(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SocialTradingMasterAccountFiltration(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SocialTradingMasterAccountFiltrationModel}
   * @param {!number} prev Previous SocialTradingMasterAccountFiltration model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SocialTradingMasterAccountFiltrationModel };
